import React, { Component } from "react";

export class UsefulLinks extends Component {
  render() {
    return (
      <>
        <section className="usefulLinksContainer">
          <span>Other Links: </span>
          <ul className="links">
            <li className="link">
              <a
                href="https://www.nseindia.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NSE
              </a>
            </li>
            <li className="link">
              <a
                href="https://www.bseindia.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                BSE
              </a>
            </li>
            <li className="link">
              <a
                href="https://ncdex.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NCDEX
              </a>
            </li>
            <li className="link">
              <a
                href="https://www.mcxindia.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MCX
              </a>
            </li>
            <li className="link">
              <a
                href="https://nsdl.co.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NSDL
              </a>
            </li>
            <li className="link">
              <a
                href="https://www.cdslindia.com/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                CDSL
              </a>
            </li>
            <li className="link">
              <a
                href="https://www.sebi.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                SEBI
              </a>
            </li>
            <li className="link">
              <a
                href="https://www.rbi.org.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                RBI
              </a>
            </li>
          </ul>
        </section>
      </>
    );
  }
}

export default UsefulLinks;
